/**
 * Anime.js - easings - ESM
 * @version v4.2.2
 * @license MIT
 * @copyright 2025 - Julian Garnier
 */

/**
 * @import {
 *   EasingFunction,
 * } from '../types/index.js'
*/

/** @type {EasingFunction} */
const none = t => t;

export { none };
